import { useState } from 'react'

const KEY = 'editor.timelineCollapsed'
/** Низкое окно или узкий экран (телефон, планшет) — лента по умолчанию свёрнута:
 *  там под превью ещё и панель блока. */
const AUTO_COLLAPSE_QUERY = '(max-height: 720px), (max-width: 1023px)'

const readInitial = (): boolean => {
  try {
    const saved = localStorage.getItem(KEY)
    if (saved !== null) return saved === '1'
  } catch {
    // Хранилище недоступно (приватное окно) — решаем по высоте окна.
  }
  return typeof window !== 'undefined' && !!window.matchMedia?.(AUTO_COLLAPSE_QUERY).matches
}

/**
 * Свёрнута ли нижняя лента экранов: вместо миниатюр — компактные плашки
 * «номер + тип». В низком окне свёрнута сама, выбор автора запоминается
 * в браузере и дальше побеждает высоту окна.
 */
export const useTimelineCollapsed = () => {
  const [collapsed, setCollapsed] = useState(readInitial)
  const toggle = () =>
    setCollapsed((prev) => {
      const next = !prev
      try {
        localStorage.setItem(KEY, next ? '1' : '0')
      } catch {
        // Не запомнили — свернётся заново при следующем открытии, не страшно.
      }
      return next
    })
  return { collapsed, toggle }
}
